import React from "react";
import { connect } from 'react-redux';
import { useQuery } from "react-query";
import { useQueryClient } from "react-query";


import { fetchParametre } from 'utils/queries';
import { patchParametre } from 'utils/posters';

import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Skeleton from '@mui/material/Skeleton';
import Button from '@mui/material/Button';

import LoadingButton from 'components/Shared/LoadingButton';
import QualificationTextField from 'components/Shared/QualificationTextField';


const AdministrationParametreRow = ({ patchParametre, code, description, autoriseEdition, autoriseVide }) => {

    const [editMode, setEditMode] = React.useState(false);
    const [saving, setSaving] = React.useState(false);


    const [valeur, setValeur] = React.useState("");
    const [edited, setEdited] = React.useState("");
    const [helperText, setHelperText] = React.useState("helper");
    const [error, setError] = React.useState(false);


    const queryClient = useQueryClient();
    const parametreQuery = useQuery([code], () => fetchParametre({ parametre: code }), {});


    React.useEffect(() => {
        if (!parametreQuery.isLoading
            && !parametreQuery.error
        ) {
            setValeur(parametreQuery.data);
        }
    }, [parametreQuery]);


    React.useEffect(() => {
        if (!autoriseVide && edited === '') {
            setHelperText("ne peut pas être vide");
            setError(true);
        }
        else {
            setHelperText("");
            setError(false);
        }
    }, [autoriseVide, edited]);


    const cancel = () => {
        setValeur(parametreQuery.data);
        setEditMode(false);
    };

    const valid = async () => {

        setSaving(true);

        const parametre = { code: code, valeur: edited };

        console.log("valid", parametre );

        var result = await patchParametre(parametre);

        setSaving(false);

        if (result) {
            setEditMode(false);
            setEdited('');
            setHelperText("");
            setError(false);
            queryClient.resetQueries(code);
        }
    };





    return (
        <TableRow hover onClick={editMode || !autoriseEdition ? null : () => { setEditMode(true); setEdited(valeur); }}>
            <TableCell>{code}</TableCell>
            <TableCell>{description}</TableCell>
            <TableCell>
                {parametreQuery.isLoading && (

                    <Skeleton />
                    
                )}
                {parametreQuery.error && (

                    error

                )}

                {!parametreQuery.isLoading && !parametreQuery.error && !editMode && (

                    valeur

                )}


                {!parametreQuery.isLoading && !parametreQuery.error && editMode && (

                    
                    <QualificationTextField
                        size="small"
                        autoFocus
                        style={{ paddingBottom: '0px' }}
                        value={edited}
                        helperText={helperText}

                        error={error}

                        onChange={e => { console.log(e.target.value); setEdited(e.target.value); }}
                    />

                )}



            </TableCell>
            <TableCell
                style={{ paddingLeft: 0, paddingRight: 0 }}
            >
                {editMode && (
                    <>
                        <Button
                            onClick={cancel}
                            disabled={saving}
                        >
                            Annuler
                        </Button>
                        <LoadingButton
                            onClick={valid}
                            disabled={error}
                            label="Sauvegarder"
                            pending={saving}
                            color="secondary"
                        />
                    </>
                 )}


            </TableCell>
        </TableRow>
    );

}



const mapDispatchToProps = {
    patchParametre
};

export default connect(null, mapDispatchToProps)(AdministrationParametreRow);